import { IonContent, IonIcon, IonLabel, IonPage, IonTab, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { happyOutline, mapOutline } from 'ionicons/icons';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useGetAirQualityMarkers } from '../../api/queries/getAirQualityMarkers';
import { useGetSingleNetwork } from '../../api/queries/getSingleNetworks';
import PageHeader from '../../components/PageHeader';
import { CurrentAQCreator } from '../../components/WidgetCreator/CurrentAQCreator';
import { MapCreator } from '../../components/WidgetCreator/MapCreator';
import { useSettings } from '../../contexts/SettingsContext';
import { NetworkId } from '../../types';

const CreateWidgetPage: React.FC<RouteComponentProps<{ networkId: NetworkId }>> = ({ match }) => {
  const { networkId } = match.params;
  const { setNetworkInfo } = useSettings();
  const { data: networkData } = useGetSingleNetwork({ networkId });
  const { data: markersData } = useGetAirQualityMarkers({ network: networkId });

  React.useEffect(() => {
    if (networkData) {
      setNetworkInfo(networkData.data.network, networkData.data.aqiStandard);
    }
  }, [networkData]);

  const availableDatasources = React.useMemo(() => {
    return markersData?.data.markers.map(({ datasourceId, datasourceName }) => ({
      datasourceId,
      datasourceName,
    }));
  }, [markersData]);

  return (
    <IonPage>
      <PageHeader title="Widget Builder" defaultHref={networkId ? `/${networkId}` : '/'} />
      <IonContent>
        <IonTabs>
          <IonTab tab="map">
            <IonContent>{networkId && <MapCreator networkId={networkId} />}</IonContent>
          </IonTab>
          <IonTab tab="currentAQ">
            <IonContent>
              {networkId && availableDatasources && (
                <CurrentAQCreator networkId={networkId} availableDatasources={availableDatasources} />
              )}
            </IonContent>
          </IonTab>

          <IonTabBar slot="top">
            <IonTabButton tab="map">
              <IonIcon icon={mapOutline} />
              <IonLabel>Map</IonLabel>
            </IonTabButton>
            <IonTabButton tab="currentAQ">
              <IonIcon icon={happyOutline} />
              <IonLabel>Current Air Quality</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonContent>
    </IonPage>
  );
};

export default CreateWidgetPage;
